(function ($) {
    let $fn = $(".comp_wsw");

    if ($fn.length) {
        $fn.on("change",".wrp_comp_navigation select",function () {
            window.location.href = $(this).val();
        })
    }
})(jQuery);